import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const Protect = () => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  return !token ? <Navigate to="/login" /> : <Outlet />;
};

export default Protect;
